const SERVICE = "market/delivery";

const getDeliveryProvider = async (api, id) =>
  api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process(`/deliverylist?store_id=${id}`);

module.exports = {
  getDeliveryProvider,
};
